<div class="modal fade show d-block sf-simple-fono-modal" tabindex="-1" role="dialog" aria-modal="true" aria-labelledby="simpleFonoModalLabel" (click)="closeModal()">
	<div class="modal-dialog modal-dialog-centered sf-simple-fono-dialog" role="document" (click)="$event.stopPropagation()">
		<div class="modal-content sf-simple-fono-content">
			<div class="modal-header">
				<h4 class="modal-title" id="simpleFonoModalLabel">Hablemos</h4>
				<button type="button" class="close" aria-label="Cerrar" (click)="closeModal()">
					<span aria-hidden="true">&times;</span>
				</button>
			</div>

			<form class="contact-form form-with-icons form-with-shadow" (ngSubmit)="submitCall()">
				<div class="modal-body sf-simple-fono-body">
					<div class="sf-intro">
						<p class="sf-intro-main">Te llamamos de inmediato, si lo deseas.</p>
						<p class="sf-intro-sub">
							Atendemos de <strong>09:00 a 17:30 hrs</strong>. Si estas fuera de ese horario, te llamamos al dia siguiente a primera hora.
							<span class="sf-intro-note">No es manual, es automatico.</span>
						</p>
						<p class="sf-intro-note mb-0">La conversación podría ser grabada.</p>
					</div>

					<div class="card sf-simple-fono-card">
						<div class="card-body">
							<div *ngIf="!showFeedback">
								<div class="form-group" *ngIf="showAreas">
									<label for="simpleFonoArea" class="form-label mb-1 text-2">Area</label>
									<select id="simpleFonoArea" class="form-control" name="area" [(ngModel)]="selectedAreaCode" [disabled]="loadingAreas">
										<option value="">-- Seleccionar area --</option>
										<option *ngFor="let area of areas" [value]="area.code">{{ area.name }}</option>
									</select>
									<small class="text-muted" *ngIf="loadingAreas">Cargando areas...</small>
								</div>

								<div class="form-group mb-3">
									<label for="simpleFonoName" class="form-label mb-1 text-2">Nombre</label>
									<input id="simpleFonoName" type="text" class="form-control text-3 h-auto py-2" name="name" maxlength="100" placeholder="Juan Perez" [(ngModel)]="name" required />
								</div>

								<div class="form-group mb-1">
									<label for="simpleFonoPhone" class="form-label mb-1 text-2">Telefono</label>
									<div class="input-group">
										<div class="input-group-prepend">
											<span class="input-group-text">+569</span>
										</div>
										<input id="simpleFonoPhone" type="tel" class="form-control text-3 h-auto py-2" name="phone" maxlength="8" placeholder="12345678" [ngModel]="phone" (ngModelChange)="onPhoneChange($event)" required />
									</div>
									<small class="text-muted">Ingresa tu telefono de 8 digitos. +569 se agrega automaticamente.</small>
								</div>
							</div>

							<div *ngIf="showFeedback" class="sf-feedback">
								<div class="sf-status-box" *ngIf="showStatus">
									{{ statusMessage }}
								</div>

								<fieldset class="sf-rating-container mt-3" [disabled]="!ratingEnabled || loadingRatingRequest">
									<p class="text-muted mb-2">
										<em>{{ ratingMessage }}</em>
									</p>
									<label class="form-label mb-1 text-2 d-block">Califica esta llamada</label>
									<div class="d-flex justify-content-center gap-2 mb-2 sf-stars">
										<button type="button" class="sf-star" [class.on]="rating >= 1" [disabled]="!ratingEnabled || loadingRatingRequest" (click)="setRating(1)" aria-label="1 estrella">&#9733;</button>
										<button type="button" class="sf-star" [class.on]="rating >= 2" [disabled]="!ratingEnabled || loadingRatingRequest" (click)="setRating(2)" aria-label="2 estrellas">&#9733;</button>
										<button type="button" class="sf-star" [class.on]="rating >= 3" [disabled]="!ratingEnabled || loadingRatingRequest" (click)="setRating(3)" aria-label="3 estrellas">&#9733;</button>
										<button type="button" class="sf-star" [class.on]="rating >= 4" [disabled]="!ratingEnabled || loadingRatingRequest" (click)="setRating(4)" aria-label="4 estrellas">&#9733;</button>
										<button type="button" class="sf-star" [class.on]="rating >= 5" [disabled]="!ratingEnabled || loadingRatingRequest" (click)="setRating(5)" aria-label="5 estrellas">&#9733;</button>
									</div>

									<div class="form-group text-left mb-3">
										<label for="simpleFonoComment" class="form-label mb-1 text-2">
											Comentario <span class="text-muted font-weight-normal">(opcional)</span>
										</label>
										<textarea id="simpleFonoComment" class="form-control text-3" name="comment" rows="3" maxlength="500" placeholder="Cuentanos como fue tu experiencia..." [(ngModel)]="comment"></textarea>
									</div>

									<button type="button" class="btn btn-sm btn-primary" [disabled]="!rating || !ratingEnabled || loadingRatingRequest" (click)="submitRating()">
										{{ loadingRatingRequest ? "Enviando..." : "Enviar calificacion" }}
									</button>
								</fieldset>
							</div>

							<div class="alert alert-danger mt-3 mb-0" *ngIf="errorMessage">
								{{ errorMessage }}
							</div>
						</div>
					</div>
				</div>

				<div class="modal-footer">
					<button type="button" class="btn btn-secondary" (click)="closeModal()">Cerrar</button>
					<button type="submit" class="btn btn-primary" [disabled]="loadingCallRequest || showFeedback">
						{{ loadingCallRequest ? "Enviando..." : "Solicitar llamada" }}
					</button>
				</div>
			</form>
		</div>
	</div>
</div>
<div class="modal-backdrop fade show"></div>
